


















































import {Component, Vue} from 'vue-property-decorator'
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import ImagesStore, { IMAGE_TYPES } from '@/store/modules/ImagesStore'
import ThemeVariableStore from '@/store/modules/ThemeVariableStore'
import ImagePreviews from "@/components/UI/ImagePreviews.vue";

@Component({
    components: {
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
        ImagePreviews,
    },
})
export default class SelectBadgeDialog extends Vue {
    private selectedItemId: number = -1;

    get languages(): CMS.Language[] {
        if (!ThemeVariableStore.all.value)
            return [];

        return ThemeVariableStore.all.value.languages;
    }

    get filteredItems(): CMS.Image[] {
        const allItems: CMS.Image[] = ImagesStore.all as CMS.Image[];
        return allItems.filter(v => v.image_type.match(IMAGE_TYPES.BADGE));
    }

    private onClickItem(itemId: number): void {
        this.selectedItemId = this.selectedItemId != itemId ? itemId : -1;
    }

    get deleteItem(): number {
        return this.selectedItemId;
    }

    get onOkSelectItem(): { [language_code: string]: string } {
        let selectItem: CMS.Image;
        selectItem = this.filteredItems.find(item => item.id == this.selectedItemId) as CMS.Image;
        if (!selectItem) {
            return {};
        }

        return selectItem.image_urls;
    }

}
